import DistributionBoard from "../classes/DistributionBoard"
import { Position } from 'reactflow';

export const distributionBoards = [
  new DistributionBoard({
    alias:"centros-de-carga", 
    svgSrc: "/symbol-assets/CentroDeCarga.svg", 
    label: "Centros de carga",
    handles: [
      {
        type: "target",
        position: Position.Top
      }      
    ]
  })
];
